import { useState } from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Reveal, SectionLabel } from "./Reveal";

const MERCH = [
  { title: "Heavyweight Hoodie", img: "/img/merch1.jpg" },
  { title: "Vol. 1 Vinyl", img: "/img/merch2.jpg" },
  { title: "Collective Tee", img: "/img/merch3.jpg" },
];
const KINDS = ["Booking", "Merch", "Collab", "Press"];

const MerchGrid = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
    {MERCH.map((m, i) => (
      <motion.div key={m.title} data-testid={`merch-item-${i}`} whileHover={{ y: -6 }} className={`group relative overflow-hidden bg-[#121216] ${i === 0 ? "h-[360px] sm:h-auto sm:row-span-2" : "h-[260px]"}`}>
        <img src={m.img} alt={m.title} className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent" />
        <div className="absolute bottom-0 p-4">
          <p className="font-display uppercase text-2xl">{m.title}</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#56ED4A]">Drop soon</p>
        </div>
      </motion.div>
    ))}
  </div>
);

const InquiryForm = () => {
  const [f, setF] = useState({ name: "", email: "", kind: "booking", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", f);
      toast.success("Got it. We'll hit you back soon.");
      setF({ name: "", email: "", kind: "booking", message: "" });
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const field = "w-full bg-transparent border border-white/25 px-4 py-4 focus:border-[#56ED4A] outline-none";
  return (
    <form onSubmit={submit} data-testid="inquiry-form" className="border border-white/10 bg-[#121216] p-6 md:p-10 flex flex-col gap-4">
      <div className="flex flex-wrap gap-2">
        {KINDS.map((k) => (
          <button type="button" key={k} data-testid={`inquiry-kind-${k.toLowerCase()}`} onClick={() => setF({ ...f, kind: k.toLowerCase() })} className={`font-mono text-xs uppercase tracking-[0.2em] px-4 py-2 border transition-colors ${f.kind === k.toLowerCase() ? "bg-[#56ED4A] text-black border-[#56ED4A]" : "border-white/20 text-zinc-300"}`}>{k}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input data-testid="inquiry-name-input" required value={f.name} onChange={set("name")} placeholder="Name" className={field} />
        <input data-testid="inquiry-email-input" required type="email" value={f.email} onChange={set("email")} placeholder="Email" className={field} />
      </div>
      <textarea data-testid="inquiry-message-input" required rows={5} value={f.message} onChange={set("message")} placeholder="Date, city, venue, what you're thinking…" className={field} />
      <button data-testid="inquiry-submit-btn" disabled={busy} className="bg-[#F4F4F6] text-black py-5 font-mono uppercase tracking-[0.2em] text-sm font-semibold hover:bg-[#56ED4A] transition-colors flex justify-center gap-2 disabled:opacity-60">
        {busy && <Loader2 className="animate-spin" size={18} />} Send it
      </button>
    </form>
  );
};

export const MerchBooking = () => (
  <section id="merch" data-testid="merch-booking-section" className="px-5 md:px-10 py-24 md:py-36 bg-[#0d0d10]">
    <Reveal>
      <SectionLabel index="07">Merch & booking</SectionLabel>
      <h2 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.85] mt-6">Wear it. <span className="chrome-text">Book us.</span></h2>
    </Reveal>
    <div className="mt-14 grid lg:grid-cols-2 gap-6 items-start">
      <Reveal><MerchGrid /></Reveal>
      <Reveal delay={0.1}><InquiryForm /></Reveal>
    </div>
  </section>
);
